import InfoIcon from "@/components/design/InfoIcon";
import axios from "axios";
import NavBar from "@/components/navigation/NavBar";
import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import Footer from "@/components/navigation/Footer";
import { FileIcon } from "@radix-ui/react-icons";
import { PinIcon } from "@/components/icons/legacy-svgs";
import { Link, useNavigate } from "react-router-dom";
import EstateDetails from "@/components/Exposepage/ExposeDetails";
import ExpandableText from "@/components/Exposepage/ExpandableText";
import EnergyCertificate from "@/components/Exposepage/EnergieAusweis";
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Dialog,
  DialogTrigger,
} from "@/components/ui/dialog";
import ContactForm from "@/components/form/ContactForm";
import config from "@/config/config";
import CtaContact from "@/components/calltoaction/CtaContact";
import ImmobilienAngebot from "@/components/Landingpage/ImmobillienAngebot";
import { IconAddressBook, IconHomeCheck } from "@tabler/icons-react";
import CarouselRosti from "@/components/test/Carousel";
import MobileBar from "@/components/navigation/MobileBar";
import { useTrackingFunctions } from "@/lib/meta/TrackingFunctions";

export default function ExposePage() {
  const [estate, setEstate] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const { trackExposeAnfrageAbgeschlossen, trackExposeAnfrageStart } =
    useTrackingFunctions();

  useEffect(() => {
    const getLastParamFromUrl = () => {
      const pathArray = window.location.pathname.split("/");
      return pathArray[pathArray.length - 1] || null;
    };

    const lastParam = getLastParamFromUrl();

    const fetchEstate = async () => {
      try {
        const response = await axios.get(
          `${config.apiUrl}/api/estates/${lastParam}`
        );
        setEstate(response.data);
        console.log(response.data);

        // Timeout to fetch the images without any layout shifts or laggy behaviour
        setLoading(false);
      } catch (error) {
        console.error("Error fetching estate:", error);
      }
    };

    fetchEstate();
  }, []);

  // Guard clause to prevent rendering until data is loaded
  if (!estate)
    return (
      <div class="logo-loader">
        <img
          src="/jakobs_logo.png"
          alt="Helga Jakobs Immobilien Logo"
          className="logo"
        />
      </div>
    );
  const images = estate.images.filter((image) => image.url);
  const merkmal =
    estate.marketing_type === "RENT" ? "Mietinteressent" : "Kaufinteressent";

  return (
    <div className="relative   bg-white ">
      <MobileBar
        merkmal={
          estate.marketing_type === "RENT"
            ? "Mietinteressent"
            : "Kaufinteressent"
        }
        immobilie={estate}
      />
      <NavBar className=" bg-opacity-90" />
      <div className=" max-w-5xl pt-20 mx-auto">
        {loading ? (
          <div className="sm:h-[40vh] h-[30vh] md:h-[60vh] rounded-lg bg-gray-400 flex justify-center items-center overflow-hidden w-full">
            <div className="w-full h-full bg-gray-200 flex animate-pulse"></div>
          </div>
        ) : (
          <CarouselRosti images={images} link={estate.links} />
        )}
      </div>
      {/* Page content below the carousel */}
      <div className="flex relative justify-center items-start max-w-5xl w-full mx-auto">
        <div className="z-20 bg-white flex-shrink max-w-3xl mx-auto p-3 md:p-6 sticky w-full">
          <div className="max-w-4xl mx-auto flex justify-between relative">
            <div className="w-full">
              <div className="breadcrumbs text-sm py-5 text-gray-300 ">
                <ul className="max-w-[calc(100vw-50px)]">
                  <li className="hover:text-gray-900">
                    <a onClick={() => navigate("/")}>Startseite</a>
                  </li>
                  <li className="hover:text-gray-900">
                    <a onClick={() => navigate("/immobilien")}>
                      Immobillienangebot
                    </a>
                  </li>
                  <li className="line-clamp-1  text-gray-500 ">
                    {estate.title?.value}
                  </li>
                </ul>
              </div>
              <h2 className="font-medium text-dark-100 line-clamp-3 font-serif text-xl md:text-3xl md:leading-10 pb-3">
                {estate.title?.value}
              </h2>
              <p className=" flex items-center gap-2">
                <PinIcon className="indent- size-5 md:size-4" />
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    estate.address
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline text-gray-600 text-sm hover:link "
                >
                  {estate.address}
                </a>
              </p>

              <Card className="w-fit rounded-sm border-l-0 border-r-0 shadow-none my-5 md:my-10 flex items-center overflow-hidden justify-center">
                <InfoIcon
                  className=""
                  price={estate.price?.value} // Extracting price value
                  living={estate.living_space?.value} // Extracting living space value
                  property={estate.plot_area?.value} // Extracting property type
                  rooms={estate.number_of_rooms?.value} // Extracting number of rooms
                  baujahr={estate.construction_year.value}
                  vermietbare_flaeche={estate.property_space_value}
                  base_rent={estate.base_rent.value}
                />
              </Card>
            </div>
          </div>
          {/* <NearbyPOIs address={estate.address} /> */}

          <div className="mx-  max-w-5xl  md:py-5">
            <ExpandableText
              label="Objektbeschreibung"
              text={estate.description_note?.value}
            />
            <EstateDetails className="my-10 md:my-16" estate={estate} />
            {estate.energy_efficiency_class.value && (
              <EnergyCertificate estate={estate} />
            )}

            <ExpandableText
              label="Ausstattung"
              text={estate.furnishing_note?.value}
            />
            <ExpandableText
              label="Lagebeschreibung"
              text={estate.location_note?.value}
            />
            <ExpandableText label="Sonstiges" text={estate.other_note?.value} />
          </div>
        </div>
        <div className="sticky border top-24 hidden  lg:flex flex-col justify-center items-center shadow-sm bg-prime-50 to-70% translate-y-2 py-4 px-2 rounded-lg ">
          {/* <p className="self-start text-lg font-medium text-prime-950">Bei Interesse</p> */}
          <div className="pt- self-center">
            <Dialog>
              <DialogTrigger
                onClick={() =>
                  trackExposeAnfrageStart(estate.id, estate.title.value)
                }
                className="btn mb-2 shadow-md w-[15rem] lg:w-[19rem] flex justify-start items-center gap-3 bg-prime-950 min-h-[2.2rem] h-[2.2rem] md:h-[3rem] hover:bg-prime-200 text-white border-none"
              >
                <FileIcon /> Expose anfragen
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Expose anfragen</DialogTitle>
                  <DialogDescription>
                    <ContactForm
                      fields={[
                        "name",
                        "email",
                        "phone",
                        "address",
                        "agbAccepted",
                        "message",
                      ]}
                      button="Expose anfragen"
                      merkmal={merkmal}
                      immobilie={estate}
                      event={() =>
                        trackExposeAnfrageAbgeschlossen(
                          estate.id,
                          estate.title.value
                        )
                      }
                      toastText="Expose"
                    />
                  </DialogDescription>
                </DialogHeader>
              </DialogContent>
            </Dialog>
          </div>
          <div className="flex pt-3 lg:w-[19rem] gap-5  border-b-0 mt-5 self-start">
            <div className="flex pl-1 border-prime-950/85 flex-col items-start justify-center rounded-none">
              <p className="text-center text-slate-500">Ihr Ansprechpartner</p>
              <div className="flex items-center gap-2">
                <div className="avatar px-2">
                  <div className="rounded-full border border-prime-100 size-16">
                    <img src={estate.broker.avatar} alt="" />
                  </div>
                </div>
                <div className="flex flex-col justify-center">
                  <p className="uppercase text-lg pt-2 text-prime-950 font-medium">
                    {estate.broker.first_name} {estate.broker.last_name}
                  </p>
                  <a className="text-gray-600 text-sm" href="">
                    {estate.broker.email}
                  </a>
                  <a className="text-gray-600 text-sm" href="">
                    {estate.broker.phone}
                  </a>
                </div>
              </div>
              <hr className="border-gray-300 w-full my-5" />
              <div className="p-5  bg-prime-50 rounded-md w-[15rem] lg:w-[19rem]   h-full">
                <IconAddressBook className="h-7 w-7 text-prime-950/70 " />
                <h3 className="text-lg text-prime-950 font-medium">
                  Sie wollen Ihre Immobilie verkaufen?
                </h3>
                <p className="text-sm  text-gray-600">
                  Ermittelten Sie schnell und unverbindlich den Marktwert Ihrer
                  Immobilie.
                </p>
                <Link to={"/bewerten"}>
                  <button className="mt-4 text-[16px] font-medium group/nav-card text-dark-200 w-full p-2 bg-gradient-to-r from-prime-100 to-prime-200 rounded-lg transition-all hover:shadow-lg hover:bg-gray-200  stroke-white text-pretty flex gap-2 justify-center items-center">
                    <IconHomeCheck />
                    Kostenlose Immobilienbewertung
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-50">
        <div className="max-w-7xl mx-auto mt-2 pb-10">
          <ImmobilienAngebot className="md:pt-7 md:pb-0" />
        </div>
      </div>
      <div className="py-20">
        <CtaContact />
      </div>

      <Footer className="relative z-20" />
    </div>
  );
}
